import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AnchorButtonComponent, ButtonComponent } from './button.component';

@NgModule({
  declarations: [ButtonComponent, AnchorButtonComponent],
  imports: [CommonModule],
  exports: [ButtonComponent, AnchorButtonComponent],
})
export class ButtonModule {}
